import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function TransactionFigures({data, loaded}){
    const colour = (amount) => {
        if(amount > 0){
            return "table-highlight-green-black-text"
        }
        else if(amount < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }

    const inverseColour = (amount) => {
        if(amount > 0){
            return "table-highlight-red"

        }
        return "table-highlight-green-black-text"
    }

    if(!loaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <Title>Misc Income/Expense</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Fixed Expenses</th>
                                <th>Total Other Expenses</th>
                                <th>Total Other Income</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={inverseColour(data.fixed_expense)}>{data.fixed_expense}</td>
                                <td className={inverseColour(data.total_expense)}>{data.total_expense}</td>
                                <td className={colour(data.total_income)}>{data.total_income}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );

}